import React from 'react';
import { SUPPLIER_COLOR_MAP } from '../../pages/Supplier/consts';
import { getProfileColorId } from '../../pages/Supplier/helpers';
import Heading from '../../generic-components/Heading';
import { useStore } from '../../store';
import { IBusiness } from '../../types';

interface IInitialsCircleProps {
  children?: React.ReactNode;
  initialsClassName: string;
  circleWrapperClassName: string;
  business?: IBusiness;
  id?: string;
  initialsLetters?: string;
}
export const InitialsCircle = ({
  children,
  initialsClassName,
  circleWrapperClassName,
  business,
  id,
  initialsLetters,
}: IInitialsCircleProps) => {
  const summary = useStore(state => state.summary);
  const { customer } = summary;
  const initials = initialsLetters || business?.initials || customer?.nameInitials;
  const customerExternalId = id || business?.customerExternalId || customer.externalId;
  return (
    <div key={`${initials}`} style={{ backgroundColor: SUPPLIER_COLOR_MAP[getProfileColorId(customerExternalId) as keyof typeof SUPPLIER_COLOR_MAP] }} className={circleWrapperClassName}>
      <Heading title={initials} className={initialsClassName} />
      {children}
    </div>
  );
};
